var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_like_4834220_000000 2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin-Entry-Edit-Page/Collapsed",
    transform: "translate(-341.000000, -1727.000000)",
    fill: "#015597",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(68.000000, 1461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_like_4834220_000000",
    transform: "translate(273.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7495979,11.980824 C19.9076775,10.9044892 19.7000387,10.0607112 19.1309602,9.47092399 C18.5618686,8.88018416 17.674063,8.58808886 16.4204691,8.58063465 C15.0601267,8.61691591 13.7075717,8.82343074 12.3898412,9.19554564 C12.1822024,8.52852523 12.3266103,7.49312894 12.8179287,6.1674235 C12.8264733,6.1469573 12.8324547,6.12556088 12.8375817,6.10416516 C13.1127214,5.02690149 13.1451834,3.89381462 12.9324281,2.79978494 C12.782895,1.95229178 12.4043516,1.17272002 11.8463942,0.559665204 C11.3371299,0.0498737577 10.7381356,-0.122239798 10.2006748,0.087073339 C9.68200437,0.28894656 9.01379863,0.92339709 8.77370219,2.79511713 C8.34988033,6.09401982 7.2860492,7.28645455 6.15902213,8.54795379 C5.700456,9.02054566 5.12786459,9.72399689 4.4412479,10.6583075 L0,10.6583075 L0,22.4733146 L4.4412479,22.4733146 L5.13041781,22.4733146 C7.53865441,22.8255766 9.41439818,23.0011383 10.7576491,23 L10.7969557,23 C13.0988279,23 16.132408,22.693775 17.6054487,21.246254 C18.236905,20.6508702 18.5718719,19.7642961 18.506926,18.857336 C18.8794736,18.5298749 19.2024751,17.9354199 19.470768,17.0814251 C19.7536076,16.1520786 19.9261988,15.1873663 19.9834667,14.2095317 C20.0227733,13.5192675 20.0091016,12.6047818 19.749342,11.9805575 L19.7495979,11.980824 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiked);
export default __webpack_public_path__ + "static/media/Liked.095fb0b93965b0853d43114ecdd52cb8.svg";
export { ForwardRef as ReactComponent };